var _g, _g2, _g3, _g4, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPuzzle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 297,
    viewBox: "0 0 296 297",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_316_1344)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 148.504,
    r: 48,
    fill: "#DF91F7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bdi_316_1344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.172 105.524C128.402 106.869 129.877 108.982 130.474 111.323L141.731 92.652L113.403 75.5722C102.038 68.72 87.2781 72.3764 80.426 83.7412L63.3462 112.069L82.0241 123.331C79.6865 123.921 77.5697 125.403 76.2252 127.633C73.5198 132.12 74.9638 137.949 79.4508 140.654C83.9377 143.359 89.7667 141.915 92.472 137.428C93.8166 135.198 94.1346 132.642 93.5697 130.292L112.248 141.553L123.509 122.875C121.166 123.444 118.603 123.122 116.372 121.778C111.885 119.073 110.442 113.244 113.147 108.757C115.852 104.27 121.685 102.819 126.172 105.524Z",
    fill: "url(#paint0_linear_316_1344)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bdi_316_1344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.267 154.282C183.963 152.57 185.011 150.208 185.011 147.604C185.011 142.365 180.765 138.118 175.526 138.118C170.286 138.118 166.04 142.365 166.04 147.604C166.04 150.208 167.088 152.562 168.785 154.282H146.975V176.093C148.687 174.396 151.049 173.348 153.653 173.348C158.892 173.348 163.139 177.594 163.139 182.834C163.139 188.073 158.892 192.319 153.653 192.319C151.049 192.319 148.695 191.271 146.975 189.574V211.385H180.053C193.316 211.385 204.077 200.632 204.077 187.361V154.282H182.267Z",
    fill: "url(#paint1_linear_316_1344)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bdi_316_1344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.653 173.348C151.049 173.348 148.696 174.396 146.975 176.093V154.283H125.173C126.87 155.995 127.918 158.357 127.918 160.961C127.918 166.2 123.671 170.447 118.432 170.447C113.192 170.447 108.946 166.2 108.946 160.961C108.946 158.357 109.994 156.003 111.691 154.283H89.8809V187.362C89.8809 200.624 100.633 211.385 113.904 211.385H146.983V189.575C148.696 191.272 151.057 192.319 153.661 192.319C158.901 192.319 163.147 188.073 163.147 182.834C163.147 177.594 158.893 173.348 153.653 173.348Z",
    fill: "#262626",
    fillOpacity: 0.6,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.653 173.348C151.049 173.348 148.696 174.396 146.975 176.093V154.283H125.173C126.87 155.995 127.918 158.357 127.918 160.961C127.918 166.2 123.671 170.447 118.432 170.447C113.192 170.447 108.946 166.2 108.946 160.961C108.946 158.357 109.994 156.003 111.691 154.283H89.8809V187.362C89.8809 200.624 100.633 211.385 113.904 211.385H146.983V189.575C148.696 191.272 151.057 192.319 153.661 192.319C158.901 192.319 163.147 188.073 163.147 182.834C163.147 177.594 158.893 173.348 153.653 173.348Z",
    fill: "black",
    fillOpacity: 0.2,
    shapeRendering: "crispEdges"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bdi_316_1344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.053 97.1881H146.975V118.998C145.262 117.301 142.9 116.253 140.296 116.253C135.057 116.253 130.811 120.5 130.811 125.739C130.811 130.979 135.057 135.225 140.296 135.225C142.9 135.225 145.254 134.177 146.975 132.48V154.29H168.785C167.088 152.578 166.04 150.216 166.04 147.612C166.04 142.372 170.286 138.126 175.526 138.126C180.765 138.126 185.011 142.372 185.011 147.612C185.011 150.216 183.963 152.57 182.267 154.29H204.077V121.211C204.077 107.941 193.316 97.1881 180.053 97.1881Z",
    fill: "#262626",
    fillOpacity: 0.6,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.053 97.1881H146.975V118.998C145.262 117.301 142.9 116.253 140.296 116.253C135.057 116.253 130.811 120.5 130.811 125.739C130.811 130.979 135.057 135.225 140.296 135.225C142.9 135.225 145.254 134.177 146.975 132.48V154.29H168.785C167.088 152.578 166.04 150.216 166.04 147.612C166.04 142.372 170.286 138.126 175.526 138.126C180.765 138.126 185.011 142.372 185.011 147.612C185.011 150.216 183.963 152.57 182.267 154.29H204.077V121.211C204.077 107.941 193.316 97.1881 180.053 97.1881Z",
    fill: "black",
    fillOpacity: 0.2,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_316_1344",
    x: 0,
    y: 0.504395,
    width: 296,
    height: 296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_316_1344"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bdi_316_1344",
    x: 38.3457,
    y: 47.1172,
    width: 128.386,
    height: 119.901,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_316_1344"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.0794
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.90902
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_316_1344",
    result: "effect2_dropShadow_316_1344"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_316_1344",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.79572
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.38716
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_316_1344"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bdi_316_1344",
    x: 121.975,
    y: 113.118,
    width: 107.103,
    height: 123.266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_316_1344"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.0794
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.90902
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_316_1344",
    result: "effect2_dropShadow_316_1344"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_316_1344",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.79572
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.38716
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_316_1344"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bdi_316_1344",
    x: 64.8809,
    y: 129.283,
    width: 123.267,
    height: 107.102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_316_1344"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.0794
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.90902
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_316_1344",
    result: "effect2_dropShadow_316_1344"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_316_1344",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.79572
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.38716
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_316_1344"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bdi_316_1344",
    x: 105.811,
    y: 72.1881,
    width: 123.267,
    height: 107.102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_316_1344"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.0794
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.90902
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_316_1344",
    result: "effect2_dropShadow_316_1344"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_316_1344",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.79572
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.38716
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_316_1344"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_316_1344",
    x1: 79.4231,
    y1: 140.477,
    x2: 116.95,
    y2: 77.9784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF91FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#FF8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEED7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_316_1344",
    x1: 175.41,
    y1: 211.247,
    x2: 175.278,
    y2: 138.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF91FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#FF8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEED7A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzle);
export default __webpack_public_path__ + "static/media/puzzle.c34141fa8a41885f1e05f0932351af6a.svg";
export { ForwardRef as ReactComponent };